import React, { useState } from 'react';

export interface IMessageDropZoneRenderProps {
    isDragging: boolean;
    containerProps: {
        onDragOver: (e: React.DragEvent<HTMLDivElement>) => void;
        onDragLeave: (e: React.DragEvent<HTMLDivElement>) => void;
        onDrop: (e: React.DragEvent<HTMLDivElement>) => void;
    };
}

export interface IMessageDropZoneProps {
    disabled?: boolean;
    onFilesDrop: (files: File[]) => void;
    children: (renderProps: IMessageDropZoneRenderProps) => React.ReactElement;
}

export const MessageDropZone: React.FC<IMessageDropZoneProps> = ({ disabled, onFilesDrop, children }) => {
    const [isDragging, setIsDragging] = useState(false);

    const handleDragOver = (e: React.DragEvent<HTMLDivElement>): void => {
        if (disabled) {
            return;
        }

        if (!e.dataTransfer.types.includes('Files')) {
            return;
        }

        e.preventDefault();
        setIsDragging(true);
    };

    const handleDragLeave = (e: React.DragEvent<HTMLDivElement>): void => {
        if (disabled) {
            return;
        }

        e.preventDefault();

        // Only mark as not dragging if the drag has actually left the container
        const relatedTarget = e.relatedTarget as (EventTarget & Node) | null;
        if (relatedTarget && e.currentTarget.contains(relatedTarget)) {
            return;
        }

        setIsDragging(false);
    };

    const handleDrop = (e: React.DragEvent<HTMLDivElement>): void => {
        if (disabled) {
            return;
        }

        e.preventDefault();
        setIsDragging(false);

        const files = Array.from(e.dataTransfer.files || []) as File[];
        if (!files.length) {
            return;
        }

        onFilesDrop(files);
    };

    return children({
        isDragging,
        containerProps: {
            onDragOver: handleDragOver,
            onDragLeave: handleDragLeave,
            onDrop: handleDrop,
        },
    });
};


